<template><span class="opacity-50">Will display here</span></template>
